import { render, staticRenderFns } from "./AreaReservada.vue?vue&type=template&id=3325fe83&scoped=true&"
import script from "./AreaReservada.vue?vue&type=script&lang=ts&"
export * from "./AreaReservada.vue?vue&type=script&lang=ts&"
import style0 from "./AreaReservada.vue?vue&type=style&index=0&id=3325fe83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325fe83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
